"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _styles = require("../../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0 0 15 15';

var RadioButtonOff = function RadioButtonOff() {
  return _react["default"].createElement("path", {
    transform: "translate(0, 0.5)",
    d: "M7.1375,0 C3.195,0 0,3.196 0,7.1375 C0,11.0795 3.195,14.2755 7.1375,14.2755 C11.0795,14.2755 14.2745,11.0795 14.2745,7.1375 C14.2745,3.196 11.0795,0 7.1375,0 M7.1375,1.115 C10.458,1.115 13.1595,3.817 13.1595,7.1375 C13.1595,10.4585 10.458,13.16 7.1375,13.16 C3.8165,13.16 1.115,10.4585 1.115,7.1375 C1.115,3.817 3.8165,1.115 7.1375,1.115"
  });
};

var svgProps = {
  color: _styles.colors.gray,
  viewBox: viewBox
};

var _default = (0, _createSvgIcon["default"])(RadioButtonOff, svgProps);

exports["default"] = _default;